import { useState, useRef } from "react";
import PhotoAlbum from "react-photo-album";
import { GALLERY } from "../data/Images";
import "./styles/gallerysection.css";

export default function Gallery() {
  const [activeRoom, setActiveRoom] = useState(0);
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const galleryRef = useRef(null);
  const room = GALLERY[activeRoom];

  const changeRoom = (index) => {
    setActiveRoom(index);

    galleryRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <>

      <section ref={galleryRef} className="gallery-page" style={{
        maxWidth: "1300px",
        margin: "20px auto",
        }}
      >

        <div className="gallery-container">

          {/* Heading */}

          <div className="gallery-heading">
            <p>PHOTO GALLERY</p>

            <h1>{room.title}</h1>

            <span>{room.subtitle}</span>
          </div>

          {/* Tabs */}

          <div className="gallery-tabs">
            {GALLERY.map((item, index) => (
              <button
                key={item.title}
                onClick={() => changeRoom(index)}
                className={
                  activeRoom === index
                    ? "gallery-tab active"
                    : "gallery-tab"
                }
              >
                {item.title}
              </button>
            ))}
          </div>

          {/* Masonry */}

          <PhotoAlbum
            layout="masonry"
            photos={room.photos}
            spacing={22}
            columns={(containerWidth) => {
              if (containerWidth < 600) return 1;
              if (containerWidth < 950) return 2;
              if (containerWidth < 1400) return 3;
              return 4;
            }}
            onClick={({ photo }) => setSelectedPhoto(photo)}
          />

          {/* Navigation */}

          <div className="gallery-navigation">
            <button
              disabled={activeRoom === 0}
              onClick={() => changeRoom(activeRoom - 1)}
            >
              ← Previous
            </button>

            <button
              disabled={activeRoom === GALLERY.length - 1}
              onClick={() => changeRoom(activeRoom + 1)}
            >
              Next →
            </button>
          </div>
        </div>
      </section>

      {/* Lightbox */}

      {selectedPhoto && (
        <div
          className="lightbox"
          onClick={() => setSelectedPhoto(null)}
        >
          <div
            className="lightbox-content"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={selectedPhoto.src}
              alt={selectedPhoto.alt}
            />

            <button
              className="lightbox-close"
              onClick={() => setSelectedPhoto(null)}
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </>
  );
}